<script setup lang="ts">
import { defineProps } from "vue";
import AppTooltip from "@/components/AppTooltip.vue";
import { Luck10 } from "@/types/calculators";

const props = defineProps<{
  startYear: number;
  data: Luck10[];
}>();

function scoreClass(score: number) {
  if (score >= 3) return "text-black border-[#c3e6cb]";
  if (score >= -5 && score <= -2) return "border-[#f5c6cb] text-black";
  return "border-[#d6d8db] text-black";
}
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-9 gap-[10px] items-stretch">
    <div
      v-for="(item, i) in props.data"
      :key="i"
      class="flex md:flex-col flex-grow gap-4 border-2 py-2 rounded-lg max-md:px-4 items-center max-md:justify-between bg-white"
      :class="scoreClass(item.score)"
    >
      <!-- YEAR -->
      <div class="font-semibold text-xl leading-[24px]">
        {{ props.startYear + i * 10 }}
      </div>

      <!-- STEM -->
      <AppTooltip>
        <template #trigger>
          <p class="cursor-pointer text-xl leading-[24px] font-normal">
            {{ item.pillar }}
          </p>
        </template>
        <template #popper>
          <div class="max-w-96 text-left">
            {{ item.tips.pillar }}
          </div>
        </template>
      </AppTooltip>

      <!-- ELEMENT -->
      <AppTooltip>
        <template #trigger>
          <img
            :src="require(`@/assets/calculators/bazi/${item.element}.png`)"
            :alt="item.element"
            class="cursor-pointer mx-auto size-10"
          />
        </template>
        <template #popper>
          <div class="max-w-96 text-left">
            {{ item.tips.element }}
          </div>
        </template>
      </AppTooltip>

      <!-- STAGE -->
      <AppTooltip>
        <template #trigger>
          <p class="cursor-pointer text-base leading-[20px] text-black">
            {{ item.stage }}
          </p>
        </template>
        <template #popper>
          <div class="max-w-96">
            <h5>{{ item.tips.stage_label }}</h5>
            <div class="text-left">{{ item.tips.stage }}</div>
          </div>
        </template>
      </AppTooltip>
    </div>
  </div>
</template>
